module.exports = __webpack_public_path__ + "img/zuijia_05.a9c2dc34.png";